import { Box } from '@mui/material';
import { AgronodIcon, Tooltip } from '@agronod/mui-components';

export const FORETAG_BORTTAGET_TEXT =
  'Företaget är borttaget, kontakta Agrosfär för mer information';

/**
 * Visas i stället för organisationsnumret när en avpseudonymiserad gårds
 * företag är borttaget (AS-4226; backoffice-api sätter `foretagBorttaget`
 * när affärspartnern raderats). Ett orgnr som bara saknas i underlaget
 * visas som "saknas", inte med denna text. Kort text med en "i" vars
 * tooltip bär hela meddelandet.
 */
export const ForetagBorttaget = () => (
  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
    Företaget är borttaget
    <Tooltip title={FORETAG_BORTTAGET_TEXT}>
      {/* span: ikonen vidarebefordrar ingen ref, Tooltip behöver en */}
      <Box
        component="span"
        tabIndex={0}
        aria-label={FORETAG_BORTTAGET_TEXT}
        sx={{
          display: 'inline-flex',
          color: 'icon.secondary',
          cursor: 'help',
          borderRadius: 0.5,
          '&:focus-visible': { outline: 2, outlineColor: 'text.primary', outlineOffset: 2 },
        }}
      >
        <AgronodIcon name="infoOutlined" sx={{ fontSize: 16 }} />
      </Box>
    </Tooltip>
  </Box>
);
